import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Spinner } from 'react-bootstrap';

import HelmetIcon from '../../../../shared/components/helmet-icon';

import { useAxios } from '../../../../shared/hooks/useAxios';

const Demo: React.FC = () => {
  const { loading, response } = useAxios(
    {
      url: `/demo/explore`,
      method: 'POST',
    },
    [],
  );

  useEffect(() => {
    if (!loading && response?.accessToken) {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      const url = new URL(`${process.env.REACT_APP_BASE_URL}/sequence`);
      url.searchParams.set('demoToken', response?.accessToken || '');

      if (ref) {
        url.searchParams.set('entryPoint', ref);
      }

      window.location.href = url.toString();
    }
  }, [loading, response]);

  return (
    <>
      <HelmetIcon />
      <Helmet>
        <title>Saleshandy Demo</title>
      </Helmet>
      <div className="demo-account-container">
        <Spinner animation="border" />

        <h1>Preparing Demo Account...</h1>
      </div>
    </>
  );
};

export default Demo;
